import { Injectable } from '@angular/core';
import { DirectoryService } from './directory.service';
import { ApiClientService } from './api-client.service';
import { UrlService } from './url.service';
import { EmptyRowService } from './empty-row.service';

declare const moment: any;

@Injectable()
export class FrontDeskInstructionsService {
    isFrontDeskInstructionsModalShow = false;
    tabId;
    data: any;
    showSpinner: boolean;
    showServiceUnavailable: boolean;
    instructionInInstructionsModal: any;
    isEditInstruction: boolean;

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public directoryService: DirectoryService
    ) { }

    getInstructions() {
        this.showSpinner = true;
        const id = JSON.parse(localStorage.getItem('residentselectedBuilding')).residentBdId;
        let url = `/v1/resident_instruction?user_id=${id}&expand=createdBy`;
        const queryParams = this.urlService.getQueryParamsString();

        if (queryParams) url = `${url}?${queryParams}`;

        this.tabId = this.urlService.queryParams['tab'];
        this.api.get('domainBD', `${url}`)
            .subscribe(
                res => {
                    this.showServiceUnavailable = false;
                    const instructions = JSON.parse(res._body);
                    this.data = instructions.entities;
                    this.data.total = instructions.total;
                    this.showSpinner = false;
                    this.data.forEach(i => {
                        const clientTimezone = moment().format('Z');
                        i.startDate = i.startDate.slice(0, -6) + clientTimezone;
                        i.endDate = i.endDate ? i.endDate.slice(0, -6) + clientTimezone : '';
                        if (moment(i.startDate)._d > moment()._d)
                            i.status = 'future';
                        else if (moment(i.endDate)._d < moment()._d)
                            i.status = 'past';
                        else if (moment()._d >= moment(i.startDate)._d && moment()._d <= moment(i.endDate)._d) {
                            i.status = 'current';
                            i.visible = true;
                        } else if (moment()._d >= moment(i.startDate)._d && !i.endDate) {
                            i.status = 'current';
                            i.visible = true;
                        }
                    });
                    this.emptyRowService.fillEmptyRow();
                }, error => {
                    this.showSpinner = false;
                    this.showServiceUnavailable = true;
                    this.api.errorHandler(error, 'Failed get Instructions');
                }
            );

    }

    resetData() {
        this.data = [];
        this.data.total = null;
    }

    editInstruction(instruction) {
        this.isEditInstruction = true;
        this.isFrontDeskInstructionsModalShow = true;
        this.directoryService.instructionsModalUser = this.data.id;
        this.directoryService.instructionsModalType = instruction.type;
        this.directoryService.instructionInInstructionsModal = instruction;
    }

    deleteInstruction(instruction) {
        this.showSpinner = true;
        this.directoryService.deleteResidentInstruction(instruction);
        setTimeout(_ => {
            this.getInstructions();
            this.showSpinner = false;
        }, 1000);
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/front-desk-instructions.service.ts